export const isServerSide = () => typeof window === "undefined";
//# sourceMappingURL=isServerSide.js.map